"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PublicDatasController", {
    enumerable: true,
    get: function() {
        return PublicDatasController;
    }
});
const _common = require("@nestjs/common");
const _platformexpress = require("@nestjs/platform-express");
const _publicdatasservice = require("~/services/public-datas.service");
const _publicapilimiterguard = require("~/guards/public-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
const _models = require("~/models");
const _attachmentsservice = require("~/services/attachments.service");
const _catchError = require("~/helpers/catchError");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let PublicDatasController = class PublicDatasController {
    async dataList(context, req, sharedViewUuid) {
        var _req_headers;
        const pagedResponse = await this.publicDatasService.dataList(context, {
            query: req.query,
            password: (_req_headers = req.headers) == null ? void 0 : _req_headers['xc-password'],
            sharedViewUuid
        });
        return pagedResponse;
    }
    async dataCount(context, req, sharedViewUuid) {
        var _req_headers;
        const pagedResponse = await this.publicDatasService.dataCount(context, {
            query: req.query,
            password: (_req_headers = req.headers) == null ? void 0 : _req_headers['xc-password'],
            sharedViewUuid
        });
        return pagedResponse;
    }
    async dataAggregate(context, req, sharedViewUuid) {
        var _req_headers;
        const response = await this.publicDatasService.dataAggregate(context, {
            query: req.query,
            password: (_req_headers = req.headers) == null ? void 0 : _req_headers['xc-password'],
            sharedViewUuid
        });
        return response;
    }
    async dataGroupBy(context, req, sharedViewUuid) {
        var _req_headers;
        return await this.publicDatasService.dataGroupBy(context, {
            query: req.query,
            password: (_req_headers = req.headers) == null ? void 0 : _req_headers['xc-password'],
            sharedViewUuid: sharedViewUuid
        });
    }
    async dataGroupByCount(context, req, sharedViewUuid) {
        var _req_headers;
        return await this.publicDatasService.dataGroupByCount(context, {
            query: req.query,
            password: (_req_headers = req.headers) == null ? void 0 : _req_headers['xc-password'],
            sharedViewUuid: sharedViewUuid
        });
    }
    async groupedDataList(context, req, sharedViewUuid, columnId) {
        var _req_headers;
        const groupedData = await this.publicDatasService.groupedDataList(context, {
            query: req.query,
            password: (_req_headers = req.headers) == null ? void 0 : _req_headers['xc-password'],
            sharedViewUuid: sharedViewUuid,
            groupColumnId: columnId
        });
        return groupedData;
    }
    async dataInsert(context, req, sharedViewUuid) {
        var _req_headers, _req_body;
        const insertResult = await this.publicDatasService.dataInsert(context, {
            sharedViewUuid: sharedViewUuid,
            password: (_req_headers = req.headers) == null ? void 0 : _req_headers['xc-password'],
            body: (_req_body = req.body) == null ? void 0 : _req_body.data,
            siteUrl: req.ncSiteUrl,
            files: req.files,
            req
        });
        return insertResult;
    }
    async relDataList(context, req, sharedViewUuid, columnId) {
        var _req_headers;
        let rowData;
        if (req.query.rowData) {
            try {
                rowData = JSON.parse(req.query.rowData);
            } catch (unused) {
                rowData = {};
            }
        }
        const pagedResponse = await this.publicDatasService.relDataList(context, {
            query: req.query,
            password: (_req_headers = req.headers) == null ? void 0 : _req_headers['xc-password'],
            sharedViewUuid: sharedViewUuid,
            columnId: columnId,
            rowData
        });
        return pagedResponse;
    }
    async publicMmList(context, req, sharedViewUuid, rowId, columnId) {
        var _req_headers;
        const paginatedResponse = await this.publicDatasService.publicMmList(context, {
            query: req.query,
            password: (_req_headers = req.headers) == null ? void 0 : _req_headers['xc-password'],
            sharedViewUuid: sharedViewUuid,
            columnId: columnId,
            rowId: rowId
        });
        return paginatedResponse;
    }
    async publicHmList(context, req, sharedViewUuid, rowId, columnId) {
        var _req_headers;
        const paginatedResponse = await this.publicDatasService.publicHmList(context, {
            query: req.query,
            password: (_req_headers = req.headers) == null ? void 0 : _req_headers['xc-password'],
            sharedViewUuid: sharedViewUuid,
            columnId: columnId,
            rowId: rowId
        });
        return paginatedResponse;
    }
    async downloadPublicAttachment(context, req, sharedViewUuid, columnId, rowId, urlOrPath) {
        var _req_headers;
        const column = await _models.Column.get(context, {
            colId: columnId
        });
        if (!column) {
            _catchError.NcError.fieldNotFound(columnId);
        }
        const record = await this.publicDatasService.dataRead(context, {
            sharedViewUuid,
            query: {
                fields: column.title
            },
            rowId,
            password: (_req_headers = req.headers) == null ? void 0 : _req_headers['xc-password']
        });
        if (!record) {
            _catchError.NcError.recordNotFound(rowId);
        }
        return this.attachmentsService.getAttachmentFromRecord({
            record,
            column,
            urlOrPath
        });
    }
    async bulkDataList(context, req, sharedViewUuid) {
        var _req_headers;
        const response = await this.publicDatasService.bulkDataList(context, {
            query: req.query,
            password: (_req_headers = req.headers) == null ? void 0 : _req_headers['xc-password'],
            sharedViewUuid,
            body: req.body
        });
        return response;
    }
    async bulkDataAggregate(context, req, sharedViewUuid) {
        var _req_headers;
        const response = await this.publicDatasService.bulkAggregate(context, {
            query: req.query,
            password: (_req_headers = req.headers) == null ? void 0 : _req_headers['xc-password'],
            sharedViewUuid,
            body: req.body
        });
        return response;
    }
    async bulkGroupBy(context, req, sharedViewUuid) {
        var _req_headers;
        const response = await this.publicDatasService.bulkGroupBy(context, {
            query: req.query,
            password: (_req_headers = req.headers) == null ? void 0 : _req_headers['xc-password'],
            sharedViewUuid,
            body: req.body
        });
        return response;
    }
    constructor(publicDatasService, attachmentsService){
        this.publicDatasService = publicDatasService;
        this.attachmentsService = attachmentsService;
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/public/shared-view/:sharedViewUuid/rows',
        '/api/v2/public/shared-view/:sharedViewUuid/rows'
    ]),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('sharedViewUuid')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], PublicDatasController.prototype, "dataList", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v2/public/shared-view/:sharedViewUuid/count'
    ]),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('sharedViewUuid')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], PublicDatasController.prototype, "dataCount", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/public/shared-view/:sharedViewUuid/aggregate',
        '/api/v2/public/shared-view/:sharedViewUuid/aggregate'
    ]),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('sharedViewUuid')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], PublicDatasController.prototype, "dataAggregate", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/public/shared-view/:sharedViewUuid/groupby',
        '/api/v2/public/shared-view/:sharedViewUuid/groupby'
    ]),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('sharedViewUuid')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], PublicDatasController.prototype, "dataGroupBy", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v2/public/shared-view/:sharedViewUuid/groupby/count'
    ]),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('sharedViewUuid')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], PublicDatasController.prototype, "dataGroupByCount", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/public/shared-view/:sharedViewUuid/group/:columnId',
        '/api/v2/public/shared-view/:sharedViewUuid/group/:columnId'
    ]),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('sharedViewUuid')),
    _ts_param(3, (0, _common.Param)('columnId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], PublicDatasController.prototype, "groupedDataList", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/public/shared-view/:sharedViewUuid/rows',
        '/api/v2/public/shared-view/:sharedViewUuid/rows'
    ]),
    (0, _common.HttpCode)(200),
    (0, _common.UseInterceptors)((0, _platformexpress.AnyFilesInterceptor)()),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('sharedViewUuid')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], PublicDatasController.prototype, "dataInsert", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/public/shared-view/:sharedViewUuid/nested/:columnId',
        '/api/v2/public/shared-view/:sharedViewUuid/nested/:columnId'
    ]),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('sharedViewUuid')),
    _ts_param(3, (0, _common.Param)('columnId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], PublicDatasController.prototype, "relDataList", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/public/shared-view/:sharedViewUuid/rows/:rowId/mm/:columnId',
        '/api/v2/public/shared-view/:sharedViewUuid/rows/:rowId/mm/:columnId',
        '/api/v1/db/public/shared-view/:sharedViewUuid/rows/:rowId/ln/:columnId',
        '/api/v2/public/shared-view/:sharedViewUuid/rows/:rowId/ln/:columnId'
    ]),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('sharedViewUuid')),
    _ts_param(3, (0, _common.Param)('rowId')),
    _ts_param(4, (0, _common.Param)('columnId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], PublicDatasController.prototype, "publicMmList", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/public/shared-view/:sharedViewUuid/rows/:rowId/hm/:columnId',
        '/api/v2/public/shared-view/:sharedViewUuid/rows/:rowId/hm/:columnId'
    ]),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('sharedViewUuid')),
    _ts_param(3, (0, _common.Param)('rowId')),
    _ts_param(4, (0, _common.Param)('columnId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], PublicDatasController.prototype, "publicHmList", null);
_ts_decorate([
    (0, _common.Get)('/api/v2/public/shared-view/:sharedViewUuid/downloadAttachment/:columnId/:rowId'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('sharedViewUuid')),
    _ts_param(3, (0, _common.Param)('columnId')),
    _ts_param(4, (0, _common.Param)('rowId')),
    _ts_param(5, (0, _common.Query)('urlOrPath')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], PublicDatasController.prototype, "downloadPublicAttachment", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v2/public/shared-view/:sharedViewUuid/bulk/dataList'
    ]),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('sharedViewUuid')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], PublicDatasController.prototype, "bulkDataList", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/public/shared-view/:sharedViewUuid/bulk/aggregate',
        '/api/v2/public/shared-view/:sharedViewUuid/bulk/aggregate'
    ]),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('sharedViewUuid')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], PublicDatasController.prototype, "bulkDataAggregate", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v2/public/shared-view/:sharedViewUuid/bulk/group'
    ]),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('sharedViewUuid')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], PublicDatasController.prototype, "bulkGroupBy", null);
PublicDatasController = _ts_decorate([
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    (0, _common.Controller)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _publicdatasservice.PublicDatasService === "undefined" ? Object : _publicdatasservice.PublicDatasService,
        typeof _attachmentsservice.AttachmentsService === "undefined" ? Object : _attachmentsservice.AttachmentsService
    ])
], PublicDatasController);
